<template>
    <inertia-head>
        <title>Vanliga frågor och svar</title>
        <meta name="description" content="Här kan du snabbt och enkelt hitta svar på många frågor rörande allt från rabattkoder, till hur man blir medlem. Psst... Alltid gratis medlemsskap!">
        <link rel="canonical" :href="canonical" />
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            <span>Frågor & Svar</span>
        </breadcrumb-item>
    </breadcrumb>

    <div class="main faq page-content-padding mb-4">
        <div class="container">
            <h1 class="page-heading text-red">Frågor & svar</h1>

            <p class="intro" style="margin-top: 25px;">
                Ibland händer det att medlemmar hör av sig och undrar över något, vi har samlat
                ihop några av de vanligaste frågorna här. Hittar du trots detta ändå inte svaret
                på din fråga är du välkommen att höra av dig till oss.
            </p>

            <h2 class="subtitle text-center pt-3">Vanliga frågor</h2>
            <div class="faq-card" v-for="question in questionsFamiljekortet" :key="question.id">
                <div class="faq-header" @click="showHide(question.id) " data-bs-toggle="collapse" :data-bs-target="'#familjekortet' + question.id" aria-expanded="true">
                    <span class="faq-question">{{question.question}}</span>
                    <icon name="chevron-down" class="ml-auto" :id="'show' + question.id"></icon>
                    <icon name="chevron-up" class="ml-auto d-none" :id="'hide' + question.id"></icon>
                </div>
                <div class="faq-body collapse" :id="'familjekortet' + question.id" v-html="'<br>'+question.answer"></div>
            </div>

            <h2 class="subtitle text-center pt-4">Medlemskap</h2>
            <div class="faq-card" v-for="question in questionsMedlemskap" :key="question.id">
                <div class="faq-header" @click="showHide(question.id) " data-bs-toggle="collapse" :data-bs-target="'#familjekortet' + question.id" aria-expanded="true">
                    <span class="faq-question">{{question.question}}</span>
                    <icon name="chevron-down" class="ml-auto" :id="'show' + question.id"></icon>
                    <icon name="chevron-up" class="ml-auto d-none" :id="'hide' + question.id"></icon>
                </div>
                <div class="faq-body collapse" :id="'familjekortet' + question.id" v-html="'<br>'+question.answer"></div>
            </div>

            <h2 class="subtitle text-center pt-4">Använda erbjudanden</h2>
            <div class="faq-card" v-for="question in questionsAnvanda" :key="question.id">
                <div class="faq-header" @click="showHide(question.id) " data-bs-toggle="collapse" :data-bs-target="'#familjekortet' + question.id" aria-expanded="true">
                    <span class="faq-question">{{question.question}}</span>
                    <icon name="chevron-down" class="ml-auto" :id="'show' + question.id"></icon>
                    <icon name="chevron-up" class="ml-auto d-none" :id="'hide' + question.id"></icon>
                </div>
                <div class="faq-body collapse" :id="'familjekortet' + question.id" v-html="'<br>'+question.answer"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['canonical'],
        data(){
            return{
                questionsFamiljekortet: [],
                questionsMedlemskap: [],
                questionsAnvanda: []
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            this.questionsFamiljekortet = [
                {
                    id: 1,
                    question: "Vad är Familjekortet?",
                    answer: "Familjekortet är ett digitalt rabattkort som är speciellt anpassat för barnfamiljer. Genom erbjudanden och rabatter gör Familjekortet vardagen, helgen, semestern och festen enklare, bättre och billigare för barnfamiljen.",
                },
                {
                    id: 2,
                    question: "Hur blir jag medlem?",
                    answer: 'Gå till <a href="/?register=true">“Bli medlem”</a> och ange där informationen som efterfrågas. Du får direkt tillgång till erbjudanden och rabatter!',
                },
                {
                    id: 3,
                    question: "Varför ska man vara medlem hos Familjekortet?",
                    answer: "Som medlem hos Familjekortet får du tillgång till grymma rabatter, erbjudanden och rabattkoder som är speciellt framtagna för att passa barnfamiljen! Vi samlar roliga aktiviteter och produkter på ett och samma ställe.",
                },
                {
                    id: 4,
                    question: "Hur loggar jag in som Företag?",
                    answer: 'Är du en av våra grymma kunder? I så fall har du tillgång till "Mina sidor Företag". Du hittar <a href="/?clientLogin=true">"Logga in företag"</a> längst ner på Startsidan. Här kan du logga in och uppdatera din Företagssida och lägga upp och redigera erbjudanden. Du ska ha fått ett mail med inloggningsuppgifter. Saknar du det så kontakta oss så hjälper vi dig! <a href="/kontakta-oss">Kontakta oss</a>',
                },
                {
                    id: 5,
                    question: "Varför har ni bytt namn från Babycard till Familjekortet?",
                    answer: "Allt är som vanligt fast mycket bättre! Babycard har bytt namn och blir Familjekortet. Vi har vuxit ur vår tidigare kostym och namnet Familjekortet gör det tydligare att detta är till för hela familjen. Det helt kostnadsfria digitala rabattkortet serverar rabattkoder och erbjudanden som gör vardagen, helgen, semestern och festen enklare, bättre och billigare för hela familjen!",
                },
            ];

            this.questionsMedlemskap = [
                {
                    id: 6,
                    question: "Kostar det att vara medlem?",
                    answer: "Det är gratis att vara medlem hos Familjekortet!",
                },
                {
                    id: 7,
                    question: "Finns det en Familjekortet-app?",
                    answer: "Ja! <br><br><a class='mr-2' href='https://play.google.com/store/apps/details?id=com.babycard.uo.babycardapplication'><img alt='Google play badge' width='120px' height='38px' src='/assets/frontend/google-play-badge.png'></a><a href='https://apps.apple.com/se/app/familjekortet-pangrabatter/id1112125417'><img alt='Appstore badge' width='120px' height='45px' src='/assets/frontend/appstore-badge.svg'></a>",
                },
                {
                    id: 8,
                    question: "Hur länge är man medlem i Familjekortet?",
                    answer: "Du är medlem så länge du önskar. Önskar du avsluta ditt medlemskap mailar du till: info@familjekortet.se",
                },
                {
                    id: 9,
                    question: "Jag har glömt mitt lösenord. Vad gör jag?",
                    answer: 'Oroa dig inte! <a href="/?forgotPassword=true">”Klicka här”</a> så kommer du till vår sida för glömt lösenord. Skriv in din e-postadress så får du ett mail skickat till dig med instruktioner för hur du kan återställa ditt lösenord.',
                },
                {
                    id: 10,
                    question: "Är kortet personligt?",
                    answer: "Medlemskapet i Familjekortet är personligt, men flera i familjen kan vara medlemmar.",
                },
                {
                    id: 11,
                    question: "Vem kan bli medlem?",
                    answer: "Alla personer kan bli medlemmar, men innehållet är anpassat för familjer med hemmaboende barn.",
                },
                {
                    id: 12,
                    question: "Varför får jag inga mail från Familjekortet?",
                    answer: "Eftersom vi kommunicerar med ord som erbjudande & rabatter är det inte ovanligt att våra mail hamnar under kampanjer, så kolla där i din mailkorg. Det är ovanligt att våra mail hamnar i skräpkorgen, men det händer. Skulle du mot förmodan inte få ett mail så kolla även där.",
                },
                {
                    id: 13,
                    question: "Vad används min information till?",
                    answer: "<b>E-post: </b>Det är framförallt via mailen vi kommunicerar med dig. Vi jobbar på att hitta bra, smarta, roliga och populära rabatter som vi vill förmedla till er och de skickas till dig bland annat via mail.<br>" +
                    "<b>Stad: </b>Vi vill gärna veta vart i vårt avlånga land du bor för att kunna visa upp så lokala rabatter som möjligt för dig. Vi uppskattar därför också om ni berättar för oss om ni flyttar på er. <br>" +
                    "<b>Födelsedatum: </b>(Ej krav) Vi önskar veta din och dina barns ålder, då vi tror att man har olika önskemål om erbjudanden och rabatter vid olika perioder i livet. Informationen använder vi för att kunna anpassa vårt innehåll efter medlemmarna. Din födelsedag gör det möjligt för oss att överraska dig på din födelsedag. Det är helt frivilligt att fylla i denna information.<br>" +
                    "<b>Telefonnummer: </b>(Ej krav) Längre fram kan det komma att bli aktuellt att vi hör av oss till er i olika avseenden, t.ex för att snabbt få ut information om nyheter genom ett sms.<br>",
                },
                {
                    id: 14,
                    question: "Vad har hänt med plastkortet?",
                    answer: "Vi har lämnat plastkorten bakom oss och använder nu endast digitala kort. Du hittar ditt kort på “Mina sidor” eller i APPen.",
                },
            ];

            this.questionsAnvanda = [
                {
                    id: 15,
                    question: "Hur gör jag för att ta del av en rabatt i en butik, restaurang, café eller liknande?",
                    answer: "Du måste vara medlem för att kunna använda erbjudanden och rabatter. I samband med köp eller bokning visar du upp ditt Familjekort i mobilen. Personalen ska vara informerad om Familjekortet och du har då rätt att erhålla rabatten som är publicerad på vår webb. Vi reserverar oss för felskrivningar och andra kommunikationsmissar som kan uppstå. Skulle det vara problem att nyttja en förmån ber vi dig snarast höra av dig till oss så att vi kan klargöra vilket erbjudande som gäller.",
                },
                {
                    id: 16,
                    question: "Hur gör jag för att använda en rabattkod i en webbshop?",
                    answer: 'Klicka på "Visa rabattkod". Kopiera rabattkoden och klistra sedan in den i webbshopens kassa när du avslutar ditt köp. Vissa erbjudanden går endast att använda vid ett tillfälle, medan andra erbjudanden och koder går att använda vid flera köp/tillfällen. Vad som gäller står angett i erbjudandet.',
                },
            ];

        },
        methods: {
            showHide(id){
                $('#show' + id).toggleClass('d-none');
                $('#hide' + id).toggleClass('d-none');
            }
        }
    }
</script>
